import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";


import Privacy from './pages/Privacy';
import ContactUs from './pages/ContactUs';
import Home from './pages';


const App = () => {
  return (
    <Router>
      <div>
        <Switch>
          <Route path="/contactus">
            <ContactUs />
          </Route>
          <Route path="/privacyPolicy">
            <Privacy />
          </Route>
          <Route path="/">
            <Home />
          </Route>
        </Switch>
      </div>
    </Router>
  );
}

export default App;
